import type { HTMLAttributes, ReactNode } from 'react'
import styles from './TiltPanel.module.css'

export interface TiltPanelProps extends HTMLAttributes<HTMLDivElement> {
  /** Which way the panel faces. */
  facing?: 'left' | 'right'
  /** Drop the tilt entirely, keeping the frame. */
  flat?: boolean
  /** Panel shadow plus brand rim. */
  lift?: boolean
  /** Render a window chrome bar above the body. */
  chrome?: boolean
  /** Caption in the chrome bar. Implies `chrome`. */
  label?: string
  children?: ReactNode
}

export function TiltPanel({
  facing = 'left',
  flat = false,
  lift = true,
  chrome = false,
  label,
  className,
  children,
  ...props
}: TiltPanelProps) {
  const showChrome = chrome || label !== undefined

  const classes = [
    styles.panel,
    facing === 'right' ? styles.right : undefined,
    lift ? styles.lift : undefined,
    flat ? styles.flat : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} {...props}>
      {showChrome && (
        <div className={styles.chrome} aria-hidden="true">
          <span className={styles.dot} />
          <span className={styles.dot} />
          {label !== undefined && <span className={styles.chromeLabel}>{label}</span>}
        </div>
      )}
      <div className={styles.body}>{children}</div>
    </div>
  )
}
